"use client";

/**
 * NavbarLogo.tsx
 *
 * Renders the restaurant's logo in the navbar.
 * Supports both custom icons (URLs) and text-only defaults.
 */

import React from "react";
import Link from "next/link";
import { Crown } from "lucide-react";

interface LogoProps {
  icon?: string;
  text?: string;
}

const NavbarLogo = ({ icon, text }: LogoProps) => {
  // Check if the icon is a valid URL image string
  const isImageUrl =
    icon && (icon.startsWith("data:") || icon.startsWith("http"));

  return (
    <Link href="/" className="flex items-center gap-2 relative z-10 group">
      {isImageUrl ? (
        <img
          src={icon}
          alt="Logo"
          className="w-10 h-10 md:w-12 md:h-12 object-contain group-hover:scale-110 transition-transform duration-300"
        />
      ) : (
        <Crown
          className="w-6 h-6 md:w-8 md:h-8 text-white group-hover:text-[#c59d5f] transition-colors"
          strokeWidth={1.5}
        />
      )}
      <span className="font-sacramento text-2xl md:text-4xl text-white group-hover:text-[#c59d5f] transition-colors transform translate-y-1">
        {text || "Royal Blue"}
      </span>
    </Link>
  );
};

export default NavbarLogo;
